define("ember-svg-jar/inlined/help-block", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<g clip-path=\"url(#a)\"><path d=\"M24 24H10l-6-6V4h14l6 6v14zM11.637 12.874v-.157c0-.31.039-.565.115-.765.075-.2.195-.374.36-.523.163-.148.37-.296.617-.445a3.53 3.53 0 001.07-.955c.268-.37.402-.835.402-1.393s-.139-1.033-.415-1.426a2.62 2.62 0 00-1.141-.9C12.16 6.103 11.602 6 10.97 6a3.96 3.96 0 00-1.579.307c-.478.205-.86.514-1.148.929-.288.415-.436.938-.445 1.57h1.937c.009-.257.071-.475.189-.65a1.14 1.14 0 01.451-.4c.183-.089.377-.134.582-.134.218 0 .414.045.589.134.175.09.314.215.419.376.104.162.156.354.156.576 0 .31-.1.574-.298.795a3.6 3.6 0 01-.735.611 3.611 3.611 0 00-.677.533c-.185.19-.327.443-.425.76-.098.315-.147.753-.147 1.31v.157h1.798zm-.042 2.815c.22-.207.33-.478.33-.814 0-.337-.11-.601-.33-.809-.22-.207-.505-.31-.854-.31-.35 0-.633.103-.854.31-.22.208-.33.477-.33.809 0 .331.11.607.33.814.22.208.505.311.854.311.35 0 .633-.103.854-.31z\"/></g><defs><clipPath id=\"a\"><path d=\"M0 0h28v28H0z\"/></clipPath></defs>",
    "attrs": {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "28",
      "fill": "currentColor",
      "viewBox": "0 0 28 28"
    }
  };
});